import axios from 'axios';
import _ from 'lodash';
import { authService } from '../../utils/auth-service';


const restClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 2000,
  headers: {
    Authorization: `Bearer ${authService.getToken()}`,
  },
});

const updateCampaignTemporaryInfluencers = (campaignId, influencer) => {
  const campaignUrl = `campaigns/${campaignId}`;
  return restClient.get(campaignUrl)
    .then(response => {
      const { attributes } = response.data.data;
      const { temporaryInfluencers } = attributes;
      console.log(temporaryInfluencers);
      const updatedInfluencers = _.reject(temporaryInfluencers, { instagram: influencer.instagram });
      console.log(updatedInfluencers);
      return updatedInfluencers;
    })
    .then(updatedInfluencers => {
      const dto = {
        data: {
          attributes: {
            temporaryInfluencers: updatedInfluencers,
          },
        },
      };
      return restClient.patch(campaignUrl, dto);
    })
    .then(response => {
      const { attributes } = response.data.data;
      const { temporaryInfluencers } = attributes;
      console.log(temporaryInfluencers);
      return temporaryInfluencers;
    });
};

const postInfluencerToDyzio = influencer => {
  const { origin } = window.location;
  const { app_metadata: { dyzio: { o_id: organisationId } } } = authService.getProfile();

  const dto = {
    data: {
      domain: origin,
      organisationId,
      influencer,
    },
  };

  console.log(dto);
  return axios.post('https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer/create', dto);
};


const createCampaignInvitation = params => restClient.post('campaignInvitation', params).then(response => {
  const { data: { data } } = response;
  const { id, type } = data;
  console.log(params);
  return restClient.post(`/campaigns/${params.data.attributes.campaign.id}/relationships/pendingInvitations/`, {
    data: { type, id },
  });
});

module.exports = {
  postInfluencerToDyzio,
  updateCampaignTemporaryInfluencers,
  createCampaignInvitation,
};



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard-influencers/data-access.js
 **/